// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 482) return "482." + __webpack_require__.h() + ".css";
	if (chunkId === 3057) return "index." + __webpack_require__.h() + ".css";
	// return url for filenames based on template
	return "" + chunkId + "." + __webpack_require__.h() + ".css";
};